<template>
  <div class="search">
    <div class="mask" v-if="!searched">
      <div class="avatar"></div>
      <input type="text" class="input" v-model="phone" placeholder="请输入您教练的手机号码">
      <a role="button" class="button" @click="search">立刻查找我的私人教练</a>
    </div>
    <div class="mask" v-else>
      <div class="avatar-wrapper">
        <img :src="coach.avatar" class="avatar">
        <div class="title">教练{{ coach.name }}需要您的验证信息</div>
      </div>
      <input type="text" class="input" v-model="message">
      <a role="button" class="button" @click="submit">发送我的验证信息</a>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';

import { ROUTE_TRAINER_APPLY_COACH_SEPARATED, ROUTE_TRAINER_APPLY_COACH_MISSING, ROUTE_TRAINER_APPLY_QRCODE } from '@/router/names';
import { SEARCH_COACH, BIND_COACH } from '@/store/trainer_apply/types';

const { mapActions: mapTrainerApplyActions, mapState: mapTrainerApplyState } = createNamespacedHelpers('trainer_apply');

export default {
    data() {
        return {
            searched: false,
            phone: '',
            message: '我是',
        };
    },
    computed: {
        ...mapTrainerApplyState({
            coach: state => state.coach || {},
            trainer_apply: state => state.trainer_apply || {},
        }),
    },
    methods: {
        ...mapTrainerApplyActions({
            searchCoach: SEARCH_COACH,
            bindCoach: BIND_COACH,
        }),
        async search() {
            this.searched = false;
            await this.searchCoach({ phone: this.phone });
            if (this.coach && this.coach.phone) {
                if (this.coach.phone === this.phone) {
                    this.searched = true;
                } else if (!this.coach.wechat_visited) {
                    this.$router.push({
                        name: ROUTE_TRAINER_APPLY_COACH_SEPARATED,
                        params: {
                            phone: this.phone,
                        },
                    });
                }
            } else {
                this.$router.push({
                    name: ROUTE_TRAINER_APPLY_COACH_MISSING,
                    params: {
                        phone: this.phone,
                    },
                });
            }
        },
        submit() {
            this.bindCoach({
                phone: this.phone,
                message: this.message,
            })
                .then(() => {
                    weui.toast('已提交申请');
                    setTimeout(() => {
                        this.$router.push({
                            name: ROUTE_TRAINER_APPLY_QRCODE,
                            params: {
                                id: this.trainer_apply.id,
                            },
                        });
                    }, 500);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.search {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-image: url(https://cdn.apeforce.cn/splash/762b96c8b963875d992ca150c774872bc98c4b83_bg-search.jpg);
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
}

.mask {
    position: absolute;
    top: 0;
    left: 32vw;
    width: 68vw;
    height: 120vw;
    padding-top: 16vw;
    backdrop-filter: blur(1vw);
    -webkit-backdrop-filter: blur(1vw);
    border: 1px solid black;

    .avatar {
        width: 68vw;
        height: 68vw;
        display: block;
    }

    .avatar-wrapper {
        position: relative;

        .title {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 68vw;
            padding-left: 3.2vw;
            box-sizing: border-box;
            background-color: rgba(0, 0, 0, 0.7);
            color: white;
            font-size: 4.266666667vw;
            height: 12.8vw;
            line-height: 12.8vw;
        }
    }

    .input {
        margin-top: 6vw;
        padding: 4vw;
        width: 68vw;
        height: 17.066666667vw;
        box-sizing: border-box;
        background-color: rgba(255, 62, 0, 0.3);
        border: 1px solid #FF3E00;
        color: #FAB3A0;
        outline: none;
        border-radius: 0;
        display: block;

        &::placeholder {
            color: #FAB3A0;
        }
    }

    .button {
        margin-top: 4vw;
        height: 12.8vw;
        box-sizing: border-box;
        padding: 2vw 4vw;
        line-height: 8.8vw;
        background-color: #FF3E00;
        color: white;
    }
}
</style>



// WEBPACK FOOTER //
// src/containers/trainer_apply/Search.vue